import React from 'react';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { BulletTrail } from '../../../../bullet-trail/bullet-trail.js';
import './wizard-bullet-trail.css';
const WIZARD_BULLET_TRAIL_LIMIT = 7;
function WizardBulletTrail(props) {
    const className = classNames({
        'c-wizard-bullet-trail': true,
        'c-wizard-bullet-trail--current-step-done': props.isCurrentStepDone,
    });
    if (!props.showTrail) {
        return null;
    }
    return (React.createElement(BulletTrail, { className: className, length: props.length, limit: WIZARD_BULLET_TRAIL_LIMIT, onClick: props.onClick, page: props.currentStepIndex }));
}
export { WizardBulletTrail, WIZARD_BULLET_TRAIL_LIMIT, };
//# sourceMappingURL=wizard-bullet-trail.js.map